export enum NameRouteEnum {
    Home = 'home',
    Search = 'search',
    Profile = 'profile',
    Settings = 'settings',
    Downloads = 'downloads',
    Subscriptions = 'subscriptions',
    Manage = 'manage',
    LinearPlayout = 'linear-playout',
    AuthCallback = 'auth/callback'
}
